import i18next from 'i18next';

import { canUpdateDeliveryTime } from '@selectors/actions/transferActions';
import { TRANSFER_DETAILS_VIEW } from '@stocks/StocksInventories/Transfers/utils/constants';

export const getActions = ({
  transferDetailsView,
  setIsReferenceDrawerOpen,
  handleExport,
  setEnableDatePicker,
  setEnableTimePicker,
  hasTransferDeliveryTime,
  authorizedActions,
}) => {
  const actions = [];

  if (
    transferDetailsView === TRANSFER_DETAILS_VIEW.DELIVERY ||
    transferDetailsView === TRANSFER_DETAILS_VIEW.RECEPTION
  ) {
    actions.push(
      {
        id: 'action-add-reference',
        label: i18next.t('ORDERS.ORDERS.FORM_ADD_NEW_REFERENCE'),
        icon: `/images/inpulse/add-black-small.svg`,
        handleClick: () => setIsReferenceDrawerOpen(true),
      },
      {
        id: 'update-transfer-date',
        label: i18next.t('ORDERS.ORDERS.ACTION_EDIT_DELIVERY_DATE'),
        icon: '/images/inpulse/edit-pen-black-small.svg',
        handleClick: () => setEnableDatePicker(true),
      },
    );

    if (hasTransferDeliveryTime && canUpdateDeliveryTime(authorizedActions)) {
      actions.push({
        id: 'update-transfer-delivery-time',
        label: i18next.t('STOCKS.TRANSFERS.UPDATE_DELIVERY_TIME'),
        icon: '/images/inpulse/edit-pen-black-small.svg',
        handleClick: () => setEnableTimePicker(true),
      });
    }
  }

  actions.push({
    id: 'action-export-transfer',
    label: i18next.t('GENERAL.EXPORT'),
    icon: '/images/inpulse/file-download-black-thick.svg',
    handleClick: handleExport,
  });

  return actions;
};
